// extracted by mini-css-extract-plugin
export default {"heroBg":"styles_heroBg__yPQk0","hero":"styles_hero__2xfMZ","ttl":"styles_ttl__LWtZ4","txt":"styles_txt__UeiPB","btns":"styles_btns__SzAZ6","img":"styles_img__5bv-7"};